// import React from 'react';

// const GenericSearch = ({
//     searchTerm,
//     setSearchTerm,
//     searchKeyType,
//     setSearchKeyType,
//     searchFields
// }) => {
//     return (
//         <div className="search-container">

//             <svg
//                 className="search-icon"
//                 xmlns="http://www.w3.org/2000/svg"
//                 viewBox="0 0 19 19"
//                 fill="none"
//             >
//                 <path
//                     d="M14.3269 14.44L17.8 17.8M16.68 8.84C16.68 13.1699 13.1699 16.68 8.84 16.68C4.51009 16.68 1 13.1699 1 8.84C1 4.51009 4.51009 1 8.84 1C13.1699 1 16.68 4.51009 16.68 8.84Z"
//                     stroke="#727171"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                 />
//             </svg>

//             <div className="search-wrapper">
//                 <input
//                     type="text"
//                     className="search-input"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     placeholder="חיפוש"
//                 />
//                 <div className="search-line"></div>
//             </div>

//             <select
//                 className="search-select"
//                 value={searchKeyType}
//                 onChange={(e) => setSearchKeyType(e.target.value)}
//             >
//                 {searchFields.map(field => (
//                     <option key={field.key} value={field.key}>
//                         {field.label}
//                     </option>
//                 ))}
//             </select>

//         </div>
//     );
// };

// export default GenericSearch;


import React from 'react';

const GenericSearch = ({
    searchTerm,
    setSearchTerm,
    checkDate = '',
    setCheckDate,
    searchKeyType,
    setSearchKeyType,
    searchFields
}) => {
    const isTransactionDateSearch = searchKeyType === 'transaction_date';
    const selectedField = searchFields.find((field) => field.key === searchKeyType);
    const hasSearchOptions = Array.isArray(selectedField?.options);

    return (
        <div className="search-container">
        {/* שדה חיפוש (יופיע בצד ימין בגלל ה-row-reverse) */}
        <select
            className="search-select"
            value={searchKeyType}
            onChange={(e) => setSearchKeyType(e.target.value)}
        >
            {searchFields.map(field => (
                <option key={field.key} value={field.key}>
                    {field.label}
                </option>
            ))}
        </select>
        <div className="search-wrapper">
            
        <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            {hasSearchOptions ? (
                <select
                    className="search-input"
                    aria-label={`בחירת ${selectedField.label}`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                >
                    <option value="">בחרי {selectedField.label}</option>
                    {selectedField.options.map((option) => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
            ) : (
                <input
                    type={isTransactionDateSearch ? 'date' : 'text'}
                    className="search-input"
                    placeholder={isTransactionDateSearch ? '' : 'חיפוש'}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            )}
          
           
        </div>
        {searchKeyType === 'payment_method' && searchTerm === 'שיק' && (
            <label className="check-date-filter">
                <span>תאריך שיק</span>
                <input
                    type="date"
                    value={checkDate}
                    onChange={(event) => setCheckDate?.(event.target.value)}
                    aria-label="סינון לפי תאריך שיק"
                />
            </label>
        )}
    
       
      
    </div>
    );
};

export default GenericSearch;